export class ktActionButtonsService

{
    constructor(GridsterService,$rootScope)
    {
        this.toolboxLoaded = false;
        this.toolboxItem = {id:null,Order:13,DirectiveName:'ktActionButtons',AngularDirectiveName:'kt-action-buttons',ElementGroup:'task',Name:'ActionButtons',Type:'actionbtns',ElementType:'actionbtns',Facss:'fa fa-font',PresentationId:null, PresentationLangId:null, FormType:'',ShowField:true,   UseDefault:false,ItemId: null, sItemValue: null,ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...", Label: 'Action buttons ',ErrorMsg:'Enter error message',MaxLength:255,Multiline:false,CodeId: 0,LabelLength:24,ValueLength:24,Parameters:{ElementWidth:24},Status:'Active'};
        this.GridsterService=GridsterService;
        this.$rootScope=$rootScope;
         var instance = this;
        
        this.$rootScope.$on('RegisterTaskWidgets',function(event, data){
        
            if (!instance.toolboxLoaded) instance.GridsterService.RegisterTaskWidget(instance.toolboxItem);
        
            instance.toolboxLoaded=true;
        });
    }
    static $inject = ['GridsterService','$rootScope'];

};


export class ktBooleanService{
    
    constructor  (GridsterService,$rootScope) {
    
        this.toolboxLoaded = false;
        this.toolboxItem = {id:null,Order:17,DirectiveName:'ktBoolean',AngularDirectiveName:'kt-boolean',ElementGroup:'dataset',Name:'Bool',Type:'bool',ElementType:'bool',Facss:'fa fa-check',PresentationId:null, PresentationLangId:null, FormType:'',ShowField:true, UseDefault:false,ItemId: null, sItemValue: null,ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...", Label: 'Yes / No',ErrorMsg:'Error message',MaxLength:255,Multiline:false,CodeId: 0,LabelLength:24,ValueLength:24,Parameters:{ElementWidth:24},Status:'Active', Dbtype:'booleanfielddefinition'};
        this.GridsterService=GridsterService;
        this.$rootScope=$rootScope;
        var instance = this;
        
        this.$rootScope.$on('RegisterDatasetWidgets',function(event, data){
        
            if (!instance.toolboxLoaded) instance.GridsterService.RegisterDatasetWidget(instance.toolboxItem);
        
            instance.toolboxLoaded=true;
        });
    }
    
    static $inject = ['GridsterService','$rootScope'];
 
     
};

export class ktDateService{
    
    constructor  (GridsterService,$rootScope) {
    
        this.toolboxLoaded = false;
        this.toolboxItem = {id:null,Order:10,DirectiveName:'ktDate',AngularDirectiveName:'kt-date',ElementGroup:'dataset',Name:'Date',Type:'date',ElementType:'date',Facss:'fa fa-calendar',PresentationId:null, PresentationLangId:null,FormType:'', ShowField:true,  UseDefault:false,ItemId: null, sItemValue: null,ItemValue: null,Saved: false,Required: true,Related: null,Label: 'Date',ErrorMsg:'Enter date', CodeId: 0,LabelLength:24,ValueLength:24,Parameters:{ElementWidth:24},Status:'Active',Dbtype : 'datetimefielddefinition'};
        this.GridsterService=GridsterService;
        this.$rootScope=$rootScope;
        var instance = this;
        
        this.$rootScope.$on('RegisterDatasetWidgets',function(event, data){
        
            if (!instance.toolboxLoaded) instance.GridsterService.RegisterDatasetWidget(instance.toolboxItem);
        
            instance.toolboxLoaded=true;
        });
    }
    
    static $inject = ['GridsterService','$rootScope'];
 
     
};
export class ktExecuteSmartContractService

{
    constructor(GridsterService,$rootScope)
    {
        this.toolboxLoaded = false;
        this.toolboxItem = {id:null,Order:13,DirectiveName:'ktExecuteSmartContract',AngularDirectiveName:'kt-execute-smart-contract',ElementGroup:'task',Name:'ExecuteSmartContract',Type:'exesm',ElementType:'exesm',Facss:'fa fa-code',PresentationId:null, PresentationLangId:null, FormType:'',ShowField:true,   UseDefault:false,ItemId: null, sItemValue: null,ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...", Label: 'Execute smart contract',ErrorMsg:'Enter error message',MaxLength:255,Multiline:false,CodeId: 0,LabelLength:24,ValueLength:24,Parameters:{ElementWidth:24},Status:'Active'};
        this.GridsterService=GridsterService;
        this.$rootScope=$rootScope;
         var instance = this;
        
        this.$rootScope.$on('RegisterTaskWidgets',function(event, data){
        
            if (!instance.toolboxLoaded) instance.GridsterService.RegisterTaskWidget(instance.toolboxItem);
        
            instance.toolboxLoaded=true;
        });
    }
    static $inject = ['GridsterService','$rootScope'];

};


export class ktFileService{
    
    constructor  (GridsterService,$rootScope) {
    
        this.toolboxLoaded = false;
        this.toolboxItem = {id:null,Order:19,DirectiveName:'ktFile',AngularDirectiveName:'kt-file',ElementGroup:'dataset',Name:'File',Type:'file',ElementType:'file',Facss:'fa fa-file',PresentationId:null, PresentationLangId:null, FormType:'',ShowField:true, UseDefault:false,ItemId: null, sItemValue: null,ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...", Label: 'File',ErrorMsg:'Error message',MaxLength:255,Multiline:false,CodeId: 0,LabelLength:24,ValueLength:24,Parameters:{ElementWidth:24},Status:'Active', Dbtype:'manytomanyfielddefinition'};
        this.GridsterService=GridsterService;
        this.$rootScope=$rootScope;
        var instance = this;
        
        this.$rootScope.$on('RegisterDatasetWidgets',function(event, data){
        
            if (!instance.toolboxLoaded) instance.GridsterService.RegisterDatasetWidget(instance.toolboxItem);
        
            instance.toolboxLoaded=true;
        });
    }
    
    static $inject = ['GridsterService','$rootScope'];
 
     
};

export class ktImageService

{
    constructor(GridsterService,$rootScope)
    {
        this.toolboxLoaded = false;
        this.toolboxItem =  {id:null,Order:17,DirectiveName:'ktImage',AngularDirectiveName:'kt-image',ElementGroup:'task',Name:'Image',Type:'img',ElementType:'img',Facss:'fas fa-image',PresentationId:null, PresentationLangId:null, FormType:'',ShowField:true, UseDefault:false,ItemId: null, sItemValue: null,ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...", Label: 'Image',ErrorMsg:'Error message',MaxLength:255,Multiline:false,CodeId: 0,LabelLength:24,ValueLength:24,Parameters:{ElementWidth:24},Status:'Active'};
        this.GridsterService=GridsterService;
        this.$rootScope=$rootScope;
        var instance = this;
        
        this.$rootScope.$on('RegisterTaskWidgets',function(event, data){
        
            if (!instance.toolboxLoaded) instance.GridsterService.RegisterTaskWidget(instance.toolboxItem);
        
            instance.toolboxLoaded=true;
        });
    }
    static $inject = ['GridsterService','$rootScope'];
     
};
export class ktKtlyoStakingService

{
    constructor(GridsterService,$rootScope)
    {
        this.toolboxLoaded = false;
        this.toolboxItem = {id:null,Order:14,DirectiveName:'ktKtlyoStaking',AngularDirectiveName:'kt-ktlyo-staking',ElementGroup:'task',Name:'KtlyoStaking',Type:'ktlyostaking',ElementType:'ktlyostaking',Facss:'fa fa-code',PresentationId:null, PresentationLangId:null, FormType:'',ShowField:true,   UseDefault:false,ItemId: null, sItemValue: null,ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...", Label: 'KTLYO staking',ErrorMsg:'Enter error message',MaxLength:255,Multiline:false,CodeId: 0,LabelLength:24,ValueLength:24,Parameters:{ElementWidth:24},Status:'Active'};
        this.GridsterService=GridsterService;
        this.$rootScope=$rootScope;
         var instance = this;
        
        this.$rootScope.$on('RegisterTaskWidgets',function(event, data){
        
            if (!instance.toolboxLoaded) instance.GridsterService.RegisterTaskWidget(instance.toolboxItem);
        
            instance.toolboxLoaded=true;
        });
    }
    static $inject = ['GridsterService','$rootScope'];

};


export class ktReadSmartContractService

{
    constructor(GridsterService,$rootScope)
    {
        this.toolboxLoaded = false;
        this.toolboxItem = {id:null,Order:14,DirectiveName:'ktReadSmartContract',AngularDirectiveName:'kt-read-smart-contract',ElementGroup:'task',Name:'ReadSmartContract',Type:'readsm',ElementType:'readsm',Facss:'fa fa-code',PresentationId:null, PresentationLangId:null, FormType:'',ShowField:true,   UseDefault:false,ItemId: null, sItemValue: null,ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...", Label: 'Read smart contract',ErrorMsg:'Enter error message',MaxLength:255,Multiline:false,CodeId: 0,LabelLength:24,ValueLength:24,Parameters:{ElementWidth:24},Status:'Active'};
        this.GridsterService=GridsterService;
        this.$rootScope=$rootScope;
         var instance = this;
        
        this.$rootScope.$on('RegisterTaskWidgets',function(event, data){
        
            if (!instance.toolboxLoaded) instance.GridsterService.RegisterTaskWidget(instance.toolboxItem);
        
            instance.toolboxLoaded=true;
        });
    }
    static $inject = ['GridsterService','$rootScope'];

};


export class ktTaskContainerService
{
    constructor(GridsterService,$rootScope)
    {
        this.toolboxLoaded = false;
        this.toolboxItem =  {id:null,Order:19,DirectiveName:'ktTaskContainer',AngularDirectiveName:'kt-task-container',ElementGroup:'task',Name:'Taskcontainer',Type:'taskcontainer',ElementType:'taskcontainer',Facss:'far fa-square',PresentationId:null, PresentationLangId:null, FormType:'',ShowField:true, UseDefault:false,ItemId: null, sItemValue: null,ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...", Label: 'Task container',ErrorMsg:'Error message',MaxLength:255,Multiline:false,CodeId: 0,LabelLength:24,ValueLength:24,Parameters:{ElementWidth:24},Status:'Active'};
        this.GridsterService=GridsterService;
        this.$rootScope=$rootScope;
        var instance = this;
        
        this.$rootScope.$on('RegisterTaskWidgets',function(event, data){
        
            if (!instance.toolboxLoaded) instance.GridsterService.RegisterTaskWidget(instance.toolboxItem);
        
            instance.toolboxLoaded=true;
        });
    }
    static $inject = ['GridsterService','$rootScope'];
     
};
export class ktTaskMessageService

{
    constructor(GridsterService,$rootScope)
    {
        this.toolboxLoaded = false;
        this.toolboxItem = {id:null,Order:18,DirectiveName:'ktTaskMessage',AngularDirectiveName:'kt-task-message',ElementGroup:'task',Name:'TaskMessage',Type:'taskmsg',ElementType:'taskmsg',Facss:'far fa-comment-alt',PresentationId:null, PresentationLangId:null, FormType:'',ShowField:true,   UseDefault:false,ItemId: null, sItemValue: null,ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...", Label: 'Task message ',ErrorMsg:'Enter error message',MaxLength:255,Multiline:false,CodeId: 0,LabelLength:24,ValueLength:24,Parameters:{ElementWidth:24},Status:'Active'};
        this.GridsterService=GridsterService;
        this.$rootScope=$rootScope;
        var instance = this;
        
        this.$rootScope.$on('RegisterTaskWidgets',function(event, data){
        
            if (!instance.toolboxLoaded) instance.GridsterService.RegisterTaskWidget(instance.toolboxItem);
        
            instance.toolboxLoaded=true;
        });
    }
    static $inject = ['GridsterService','$rootScope'];
    
};
export class ktTaskViewChartService

{
    constructor(GridsterService,$rootScope)
    {
        this.toolboxLoaded = false;
        this.toolboxItem = {id:null,Order:21,DirectiveName:'ktTaskViewChart',AngularDirectiveName:'kt-task-view-chart',ElementGroup:'task',Name:'ViewChart',Type:'taskviewchart',ElementType:'taskviewchart',Facss:'far fa-file-pdf',PresentationId:null, PresentationLangId:null, FormType:'',ShowField:true,   UseDefault:false,ItemId: null, sItemValue: null,ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...", Label: 'Task View Chart ',ErrorMsg:'Enter error message',MaxLength:255,Multiline:false,CodeId: 0,LabelLength:24,ValueLength:24,Parameters:{ElementWidth:24},Status:'Active'};
        this.GridsterService=GridsterService;
        this.$rootScope=$rootScope;
        var instance = this;
        
        this.$rootScope.$on('RegisterTaskWidgets',function(event, data){
        
            if (!instance.toolboxLoaded) instance.GridsterService.RegisterTaskWidget(instance.toolboxItem);
        
            instance.toolboxLoaded=true;
        });
    }
    static $inject = ['GridsterService','$rootScope'];
    
};
export class ktTaskViewPdfService

{
    constructor(GridsterService,$rootScope)
    {
        this.toolboxLoaded = false;
        this.toolboxItem = {id:null,Order:18,DirectiveName:'ktTaskViewPdf',AngularDirectiveName:'kt-task-view-pdf',ElementGroup:'task',Name:'ViewPdf',Type:'taskviewpdf',ElementType:'taskviewpdf',Facss:'far fa-file-pdf',PresentationId:null, PresentationLangId:null, FormType:'',ShowField:true,   UseDefault:false,ItemId: null, sItemValue: null,ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...", Label: 'Task View Pdf ',ErrorMsg:'Enter error message',MaxLength:255,Multiline:false,CodeId: 0,LabelLength:24,ValueLength:24,Parameters:{ElementWidth:24},Status:'Active'};
        this.GridsterService=GridsterService;
        this.$rootScope=$rootScope;
        var instance = this;
        
        this.$rootScope.$on('RegisterTaskWidgets',function(event, data){
        
            if (!instance.toolboxLoaded) instance.GridsterService.RegisterTaskWidget(instance.toolboxItem);
        
            instance.toolboxLoaded=true;
        });
    }
    static $inject = ['GridsterService','$rootScope'];
    
};
export class ktTextboxService{
    
    constructor  (GridsterService,$rootScope) {
    
        this.toolboxLoaded = false;
        this.toolboxItem = {id:null,Order:6,DirectiveName:'ktTextbox',AngularDirectiveName:'kt-textbox',ElementGroup:'dataset',Name:'Text',Type:'textbox',ElementType:'textbox',Facss:'fa fa-font',PresentationId:null, PresentationLangId:null, FormType:'',ShowField:true, UseDefault:false,ItemId: null, sItemValue: null,ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...", Label: 'Text',ErrorMsg:'Error message',MaxLength:255,Multiline:false,CodeId: 0,LabelLength:24,ValueLength:24,Parameters:{ElementWidth:24},Status:'Active', Dbtype:'charfielddefinition'};
        this.GridsterService=GridsterService;
        this.$rootScope=$rootScope;
        var instance = this;
        
        this.$rootScope.$on('RegisterDatasetWidgets',function(event, data){
        
            if (!instance.toolboxLoaded) instance.GridsterService.RegisterDatasetWidget(instance.toolboxItem);
        
            instance.toolboxLoaded=true;
        });
    }
    
    static $inject = ['GridsterService','$rootScope'];
 
     
};

export class ktTreeViewService{
    
    constructor  (GridsterService,$rootScope) {
     this.toolboxLoaded = false;
        this.toolboxItem = {id:null,Order:6,DirectiveName:'ktTreeView',AngularDirectiveName:'kt-tree-view',ElementGroup:'task',Name:'TreeView',Type:'treev',ElementType:'treev',Facss:'fa fa-font',PresentationId:null, PresentationLangId:null, FormType:'',ShowField:true,   UseDefault:false,ItemId: null, sItemValue: null,ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Unesite...", Label: 'TreeView ',ErrorMsg:'Upišite test ',MaxLength:255,Multiline:false,CodeId: 0,LabelLength:24,ValueLength:24,Parameters:{ElementWidth:24},Status:'Active'};
        this.GridsterService=GridsterService;
        this.$rootScope=$rootScope;
        var instance = this;
        
        this.$rootScope.$on('RegisterTaskWidgets',function(event, data){
        
            if (!instance.toolboxLoaded) instance.GridsterService.RegisterTaskWidget(instance.toolboxItem);
        
            instance.toolboxLoaded=true;
        });
    }
    
    static $inject = ['GridsterService','$rootScope'];
    
};
export class ktUploadFileService

{
    constructor(GridsterService,$rootScope)
    {
        this.toolboxLoaded = false;
        this.toolboxItem =  {id:null,Order:20,DirectiveName:'ktUploadFile',AngularDirectiveName:'kt-upload-file',ElementGroup:'task',Name:'UploadFile',Type:'uploadfile',ElementType:'uploadfile',Facss:'fa fa-upload',PresentationId:null, PresentationLangId:null, FormType:'',ShowField:true, UseDefault:false,ItemId: null, sItemValue: null,ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...", Label: 'Upload file (novo)',ErrorMsg:'Error message',MaxLength:255,Multiline:false,CodeId: 0,LabelLength:24,ValueLength:24,Parameters:{ElementWidth:24},Status:'Active'};
        this.GridsterService=GridsterService;
        this.$rootScope=$rootScope;
        var instance = this;
        
        this.$rootScope.$on('RegisterTaskWidgets',function(event, data){
        
            if (!instance.toolboxLoaded) instance.GridsterService.RegisterTaskWidget(instance.toolboxItem);
        
            instance.toolboxLoaded=true;
        });
    }
    static $inject = ['GridsterService','$rootScope'];
     
};
export class ktWeb3WalletService

{
    constructor(GridsterService,$rootScope)
    {
        this.toolboxLoaded = false;
        this.toolboxItem = {id:null,Order:20,DirectiveName:'ktWeb3Wallet',AngularDirectiveName:'kt-web3-wallet',ElementGroup:'task',Name:'Web3Wallet',Type:'web3',ElementType:'web3',Facss:'fa fa-wallet',PresentationId:null, PresentationLangId:null, FormType:'',ShowField:true,   UseDefault:false,ItemId: null, sItemValue: null,ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...", Label: 'Web3 wallet',ErrorMsg:'Enter error message',MaxLength:255,Multiline:false,CodeId: 0,LabelLength:24,ValueLength:24,Parameters:{ElementWidth:24},Status:'Active'};
        this.GridsterService=GridsterService;
        this.$rootScope=$rootScope;
         var instance = this;
        
        this.$rootScope.$on('RegisterTaskWidgets',function(event, data){
        
            if (!instance.toolboxLoaded) instance.GridsterService.RegisterTaskWidget(instance.toolboxItem);
        
            instance.toolboxLoaded=true;
        });
    }
    static $inject = ['GridsterService','$rootScope'];

};


export class ktWriteSmartContractService

{
    constructor(GridsterService,$rootScope)
    {
        this.toolboxLoaded = false;
        this.toolboxItem = {id:null,Order:13,DirectiveName:'ktWriteSmartContract',AngularDirectiveName:'kt-write-smart-contract',ElementGroup:'task',Name:'WriteSmartContract',Type:'writesm',ElementType:'writesm',Facss:'fa fa-code',PresentationId:null, PresentationLangId:null, FormType:'',ShowField:true,   UseDefault:false,ItemId: null, sItemValue: null,ItemValue: null,Saved: false,Required: true,Related: null,SearchText:"Enter...", Label: 'Write smart contract',ErrorMsg:'Enter error message',MaxLength:255,Multiline:false,CodeId: 0,LabelLength:24,ValueLength:24,Parameters:{ElementWidth:24},Status:'Active'};
        this.GridsterService=GridsterService;
        this.$rootScope=$rootScope;
         var instance = this;
        
        this.$rootScope.$on('RegisterTaskWidgets',function(event, data){
        
            if (!instance.toolboxLoaded) instance.GridsterService.RegisterTaskWidget(instance.toolboxItem);
        
            instance.toolboxLoaded=true;
        });
    }
    static $inject = ['GridsterService','$rootScope'];

};

